import { render, staticRenderFns } from "./invInfo.vue?vue&type=template&id=e6061ee4"
import script from "./invInfo.vue?vue&type=script&lang=js"
export * from "./invInfo.vue?vue&type=script&lang=js"
import style0 from "./invInfo.vue?vue&type=style&index=0&id=e6061ee4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports